"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentDetailsPanel = void 0;
var PaymentCard_cms_1 = require("../components/cards/PaymentCard/PaymentCard.cms");
var SplitPaymentCard_cms_1 = require("../components/cards/SplitPaymentCard/SplitPaymentCard.cms");
var BankAccountDetailsCardCms_cms_1 = require("../components/cards/PaymentCard/BankAccountDetailsCard/BankAccountDetailsCardCms.cms");
var PaymentValidityDetailsCardCms_cms_1 = require("../components/cards/PaymentCard/PaymentValidityDetailsCard/PaymentValidityDetailsCardCms.cms");
var PaymentDetailsPanelCms_cms_1 = require("../components/panels/PaymentDetailsPanel/PaymentDetailsPanelCms.cms");
var PaymentScheduleModalCms_cms_1 = require("./../components/panels/PaymentDetailsPanel/PaymentScheduleModal/PaymentScheduleModalCms.cms");
var PaymentDetailsPanel = /** @class */ (function () {
    function PaymentDetailsPanel() {
        this.paymentForm = new PaymentCard_cms_1.PaymentCardCms();
        this.bankAccountDetailsForm = new BankAccountDetailsCardCms_cms_1.BankAccountDetailsCardCms();
        this.paymentValidityDetailsForm = new PaymentValidityDetailsCardCms_cms_1.PaymentValidityDetailsCardCms();
        this.panelContent = new PaymentDetailsPanelCms_cms_1.PaymentDetailsPanelCms();
        this.splitPaymentForm = new SplitPaymentCard_cms_1.SplitPaymentCardCms();
        this.paymentScheduleModalContent = new PaymentScheduleModalCms_cms_1.PaymentScheduleModalCms();
    }
    return PaymentDetailsPanel;
}());
exports.PaymentDetailsPanel = PaymentDetailsPanel;
//# sourceMappingURL=PaymentDetailsPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/cms/PaymentDetailsPanel.cms.js
// module id = 2025
// module chunks = 8